export enum BuyerContractsActionTypes {
  SET_BUYER_CONTRACTS = 'SET_BUYER_CONTRACTS',
}

export interface Contract {
  contractId: string
  contractIdentifier: string
  awsAccountId: string
  awsCustomerIdentifier?: string | null
  createdAt: string
  contractStartDate?: string | null
  contractExpirationDate?: string | null
  tcv: number
  autoRenew?: boolean | null
  contractStatus: string
  expiringOn: string | null
  productName: string
  productType: string
  productId: string
  contractName: string
  cloudOfferId: string
  offerType: string
  aboAgreementId: string | null
  creatorName: string | null
  offerSentAt: string | null
  offerViewedAt: string | null
  offerAcceptedAt?: string | null
}

export interface Contracts {
  contracts: Contract[]
}

export const initialBuyerContractsState: Contracts = { contracts: [] }

export type BuyerContractsAction = {
  type: BuyerContractsActionTypes.SET_BUYER_CONTRACTS
  payload: Contracts
}
